import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import ContentContainer from "../../components/contentContainer/contentContainer.js"
import Layout from "../../components/layout/layout.js"
import Seo from "../../components/seo"
import P from "../../components/p/p.js"
import PageSection from "../../components/pageSection/pageSection.js"
import SharedFooter from "../../components/sharedFooter/sharedFooter.js"

import { DifferentiatorsSection } from "../../components/aboutSections/differentiators/differentiators.js"
import { SupportersSection } from "../../components/aboutSections/supporters/supporters.js"

import styles from "./index.module.scss"

const description = "Till gives you the tools and resources needed to help your kids stay accountable and develop the confidence needed to make better money choices—together."

const AboutPage = () => {
  const data = useStaticQuery(graphql`
    query {
      aboutHero: file(relativePath: { eq: "about/about-hero.jpg" }) {
        childImageSharp {
          gatsbyImageData (
            width: 1440
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  return (
    <Layout useWhiteHeaderBg={false}>
      <Seo
        title="About Us: What Makes Till Different | Our Mission "
        description={`${description}`}
      />

      <section style={{ backgroundColor: "#eff3f9" }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", maxHeight:"600px", }}>
          <GatsbyImage
            image={getImage(data.aboutHero)}
            alt="Teenager holding a Till debit card and a phone with the Till Financial app opened on the spending page"
          />
        </div>
      </section>

      <PageSection backgroundColor="#0fd1ab">
        <div className={styles.missionCopyContainer}>
          <h2 className={styles.missionHeading}>Our Mission</h2>
          <P className={styles.missionCopy}>
            {description}
          </P>
        </div>
      </PageSection>

      <DifferentiatorsSection />

      <SupportersSection />

      <PageSection backgroundColor="#eff3f9">
        <ContentContainer>
          <SharedFooter />
        </ContentContainer>
      </PageSection>
    </Layout>
  )
}

export default AboutPage
